import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children, requireAdmin = false, allowedRoles = [] }) {
    const { user, profile, loading } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#667eea'
            }}>
                Chargement...
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const userRole = profile?.role;

    // If specific roles are required, check against them
    if (allowedRoles.length > 0) {
        if (!allowedRoles.includes(userRole)) {
            // Redirect based on role
            if (userRole === 'producteur') return <Navigate to="/jobs" replace />;
            if (userRole === 'client') return <Navigate to="/client-dashboard" replace />;
            return <Navigate to="/dashboard" replace />;
        }
    }

    // Legacy support: requireAdmin flag
    if (requireAdmin && userRole !== 'admin') {
        if (userRole === 'producteur') return <Navigate to="/jobs" replace />;
        return <Navigate to="/client-dashboard" replace />;
    }

    return children;
}

export default ProtectedRoute;

